// TODO: Overhaul — delete this file once `/v1/dashboard/investor` is served. Interim, it fills the one field
// the create flow needs — `stats.onCallInterestRate` — from the live on-call account endpoint (API2
// `/v2/on-call-accounts/{entityId}`, the same `interestRate` the on-call account page and Home Wallet card
// show). At cut-over, drop it from the overhaul seam and the dashboard query flows to the real client unchanged.
import { Client } from 'openapi-fetch';

import { ok } from '@views/investor/queries/overhaul-mock.util';

import {
  SquirrelMoneyCoreContractsDashboardInvestorDto as DashboardInvestorDto,
  paths as accountOverhaulPaths,
} from '@core/schemas/account-overhaul-schema';
import { paths as api2Paths } from '@core/schemas/api2-schema';

/**
 * A mock `ACCOUNT_OVERHAUL_CLIENT` fragment serving `GET /v1/dashboard/investor` by filling
 * `stats.onCallInterestRate` from the live `GET /v2/on-call-accounts/{entityId}` (`interestRate`). That one
 * stat is all the create flow reads; the rest of `DashboardInvestorDto` is left absent.
 *
 * The dashboard endpoint is user-scoped (no entityId in its path), so the seam passes `getEntityId` — the
 * current investor entity, read from the route — since the on-call rate the mock fills is entity-scoped.
 * Composed into the single overhaul seam (`createOverhaulMockClient`); handles only the dashboard GET.
 */
export function createDashboardInvestorMockClient(options: {
  api2: Client<api2Paths>;
  getEntityId: () => number | null;
}): Client<accountOverhaulPaths> {
  const { api2, getEntityId } = options;
  return {
    async GET() {
      const entityId = getEntityId();
      if (entityId === null) return ok<DashboardInvestorDto>({ stats: {} });
      const { data } = await api2.GET('/v2/on-call-accounts/{entityId}', { params: { path: { entityId } } });
      return ok<DashboardInvestorDto>({ stats: { onCallInterestRate: data?.interestRate } });
    },
    // Cast: this stub implements only the dashboard GET, not the whole overhaul surface.
  } as unknown as Client<accountOverhaulPaths>;
}
